import { fetchEntryById } from '../data/fetchEntryById';

export function createHandleListClick({
  entries,
  setCurrentIndex,
  setCurrentEntryId,
  setForm,
  setActiveTab,
  setListPageClicked,
  listPageNo,
  token,
}) {
  return async function handleListClick(entryId) {
    try {
      const entry = await fetchEntryById(entryId, token);

      const index = entries.findIndex((e) => e.id === entryId);
      if (index !== -1) {
        setCurrentIndex(index);
        setCurrentEntryId(entryId);
        setListPageClicked(listPageNo);

        setForm({
          category: entry.category,
          title: entry.title,
          keywords: entry.keywords,
          detail: entry.detail, // full detail now loaded
          isPublic: entry.is_public,
          dataOwnerId: entry.user_id,
          sharedName: entry.shared_name,
          shareProfilePicture: entry.share_profile_picture,
          profilePicture: entry.profile_picture,
          updatedAt: entry.updated_at,
        });

        if (setActiveTab) setActiveTab('entry');
      }
    } catch (err) {
      console.error(`Error fetching entry ${entryId}:`, err);
    }
  };
}
